module.exports = __webpack_public_path__ + "img/bigparty.cc37e6ce.svg";